import React from "react";

const Rupees = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path  className="u_fill"
            d="M18 2C9.164 2 2 9.164 2 18s7.164 16 16 16 16-7.164 16-16S26.836 2 18 2zm3.898 12H23a1 1 0 010 2h-1.102A5.006 5.006 0 0117 20h-1.586l6.292 6.292a1 1 0 01-1.414 1.416l-8-8A1 1 0 0113 18h4a2.995 2.995 0 002.816-2H13a1 1 0 010-2h6.816A2.995 2.995 0 0017 12h-4a1 1 0 010-2h10a1 1 0 010 2h-2.026c.442.584.774 1.256.924 2z"
            fill={fill}
        />
    </svg>
);
export default Rupees;
